var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJobSiteInvert({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    enableBackground: "new 0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M410.9,156.5c0.8,27.6-6.4,52-17.7,75.2c-10.7,22-22,43.8-32.5,66c-12.6,26.6-25.5,53.2-38.6,79.6 c-12.9,26.1-25.3,52.4-38.2,78.5c-8,16.4-15.6,32.9-23.6,49.3c-0.6,1.2-0.6,3.5-2.5,3.3c-1.8,0-2.1-2.1-2.7-3.5 c-14.2-29.4-28.6-58.8-43-88.4c-11.5-23.9-23.3-47.9-35-71.8c-13.4-27.6-27.2-54.9-39.9-82.7c-8.1-17.5-17.9-34.3-24-52.7 c-4.5-13.5-7.2-27.2-8.1-41.6c-1.8-27.9,3.6-54.1,16.2-78.8c13.4-26.3,32.6-47,58-62.1c18.3-10.9,38-17.7,59.2-20.1 c22.8-2.7,45-1.2,66.8,6c20.6,6.8,38.9,17.5,55.3,32.1c25.3,22.4,40.3,50.4,47.6,82.7C410.4,137.2,412.4,147.6,410.9,156.5z  M258.2,74.9c-46.1-0.8-84.5,37.2-84.3,83.5c0.3,46.1,35.6,83.9,84.3,83.9c45.5,0,81.4-34.8,83.5-80.6 C343.9,112.9,302.9,74,258.2,74.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M258.4,74.9c44.8-0.9,85.7,38,83.5,86.8c-2.1,45.8-38,80.6-83.5,80.6c-48.5,0-83.9-37.8-84.3-83.9 C173.9,112.1,212.3,74.1,258.4,74.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobSiteInvert);
export default __webpack_public_path__ + "static/media/job-site-invert.3f177e2aea0b67cc4952ac485539ca2f.svg";
export { ForwardRef as ReactComponent };